import React from 'react';
import Button from '../../components/button/Button';
import "./explanation.css";


const Explanation = () => {
  return (
    <div className='explanation-container'>

    <Button text="Atrás" route="/" />

    <div className="explanation-card">
        <div className="explanation-text">
            Hay momentos donde el televisor empieza a deteriorar su funcionamiento. Esto puede ser consecuencia natural del paso del tiempo, como también alguna falla en su sistema por la falta de actualizaciones. Para estos casos, lo más simple es buscar si existe alguna actualización del firmware del dispositivo, lo que permite mejorar su rendimiento.
        </div>

        <div className="explanation-title">
            ¿Qué es un Firmware?
        </div>
        <div className="explanation-text">
            Se trata del software instalado en el Smart TV que se actualiza periódicamente para mejorar sus herramientas principales, al mismo tiempo que le permite al dispositivo acceder a nuevas funciones.
        </div>
        <div className="explanation-text">
            Aunque muchos televisores lo traen incorporado y se actualiza de forma automática, otros lo tienen desactualizado. Por ello, es fundamental revisarlo de manera periódica para que no empiece a fallar.
        </div>

        <div className="explanation-title">
            Beneficios de Actualizar el Firmware
        </div>
        <div className="explanation-text">
            <strong>Mejoras en la estabilidad:</strong> las actualizaciones de firmware suelen corregir errores y problemas de estabilidad que pueden afectar el rendimiento del televisor.
        </div>
        <div className="explanation-text">
            <strong>Nuevas funciones:</strong> a menudo, las actualizaciones incluyen nuevas características y capacidades que pueden enriquecer tu experiencia, como nuevas aplicaciones o mejoras en la interfaz de usuario.
        </div>
        <div className="explanation-text">
            <strong>Compatibilidad:</strong> con el tiempo, los estándares y formatos de medios cambian. Actualizar el firmware puede garantizar que tu televisor sea compatible con los últimos formatos de video y audio, como también con los servicios de streaming.
        </div>
        <div className="explanation-text">
            <strong>Mejora en el rendimiento:</strong> las actualizaciones pueden optimizar el rendimiento general del dispositivo, mejorando la velocidad de respuesta y la calidad de imagen.
        </div>
        <div className="explanation-text">
            <strong>Seguridad:</strong> al igual que cualquier dispositivo conectado a Internet, los televisores pueden ser vulnerables a amenazas de seguridad. Las actualizaciones de firmware pueden incluir parches de seguridad que protegen tu dispositivo.
        </div>
        <div className="explanation-text">
            <strong>Corrección de problemas:</strong> si se experimentan problemas específicos, como conectividad con dispositivos externos, las actualizaciones pueden solucionar estos inconvenientes.
        </div>
        <div className="explanation-text">
            <strong>Optimización de la calidad de imagen:</strong> algunas actualizaciones pueden incluir mejoras en el procesamiento de video, lo que resulta en una mejor calidad de imagen.
        </div>

        <div className="explanation-title">
            ¿Qué pasa si mi TV no enciende y se queda en Stand By?
        </div>
        <div className="explanation-text">
            En ese caso, <strong>puede</strong> que instalando el Firmware que corresponda a su modelo de TV solucione el problema, a menudo ese tipo de problemas se solucionan al hacer la reinstalación de su firmware, y en el caso que no pueda acceder a la pantalla para realizar su instalación (como en el caso mencionado), deberá hacer una instalación "Forzada" del mismo.
        </div>
        <div className="explanation-text">
            Recuerde que, si bien todos los archivos cuentan con su guía de instrucciones para su instalación, se deben tener conocimientos técnicos a la hora de diagnosticar el error en su TV, como así tambien el correcto uso de estos archivos.
        </div>
    </div>

  </div>
  )
}

export default Explanation